// extracted by mini-css-extract-plugin
export var content = "PageMarkdown-module--content--5241d";
export var teaser = "PageMarkdown-module--teaser--af6f8";